import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'train-option',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './train-option.component.html'
})
export class TrainOptionComponent {


  // [callBack] 回傳父組件事件
  @Output() callBack =  new EventEmitter<{ option: any }>();
  optionForm: FormGroup;


  constructor(private build: FormBuilder) {}
  ngOnInit() {
    this.optionForm = this.build.group({
      timeWay: ['now'] ,
      goTime:[''] ,
      trafficWay: this.build.group({
        3: true,
        4: true,
        5: true,
        6: true,
        8: true,
      }),
      transferTime: [30],
      gc: [0.5],
      firstMode: this.build.group({
        0: true,
        2: true,
        3: true,
        time0: [30],
        time2: [30],
        time3: [30],
      }),
      lastMode: this.build.group({
        0: true,
        2: true,
        3: true,
        time0: [30],
        time2: [30],
        time3: [30],
      }),
    });
  }



  showDetail(){
    this.callBack.emit(
      {
        option:this.optionForm.value
      }
    );
  }
}
